// folktale.ai's tags, as the /welcome snapshot loaded them: Consent Mode
// defaults to denied and is restored from the visitor's stored choice before
// GA4, Google Ads and the GTM container run. CookieConsent records the choice.
const GTM_ID = "GTM-M9XTR9DL";
const GA_MEASUREMENT_ID = "G-BM084T15BE";
const GOOGLE_ADS_ID = "AW-18323907901";

export const CONSENT_STORAGE_KEY = "folktale.cookie-consent";

const CONSENT_AND_CONFIG = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  wait_for_update: 500
});
try {
  var stored = localStorage.getItem('${CONSENT_STORAGE_KEY}');
  if (stored === 'granted' || stored === 'denied') {
    gtag('consent', 'update', {
      ad_storage: stored,
      ad_user_data: stored,
      ad_personalization: stored,
      analytics_storage: stored
    });
  }
} catch (e) {}
gtag('js', new Date());
var ftLinker = { domains: ['folktale.io','www.folktale.io','app.folktale.io','folktale.ai','www.folktale.ai','landingpages.folktale.io'], accept_incoming: true };
gtag('config', '${GA_MEASUREMENT_ID}', { linker: ftLinker });
gtag('config', '${GOOGLE_ADS_ID}', { linker: ftLinker });
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`;

// Production IDs: staging, previews and local dev must not send them traffic.
const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";

/** Rendered in <head>: the consent default must run before any tag loads. */
export function SiteAnalyticsHead() {
  if (!IS_PRODUCTION) return null;
  return (
    <>
      <script dangerouslySetInnerHTML={{ __html: CONSENT_AND_CONFIG }} />
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} />
    </>
  );
}

export function SiteAnalyticsNoScript() {
  if (!IS_PRODUCTION) return null;
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  );
}
